<h2 mat-dialog-title>Saída de Séries</h2>

<mat-dialog-content>
  <div class="produto-info">
    <span class="produto-nome">{{ nomeProduto }}</span>
    @if (skuProduto) {
      <span class="produto-sku">SKU: {{ skuProduto }}</span>
    }
    <span class="status-badge status-qtd"
          [class.badge-vermelho]="statusBadge === 'vazio'"
          [class.badge-amarelo]="statusBadge === 'parcial'"
          [class.badge-verde]="statusBadge === 'ok'">
      {{ isNarrow ? 'Qtd. necessária' : 'Quantidade necessária' }}: {{ quantidadeTotal }}
      / {{ isNarrow ? 'Qtd. informada' : 'Quantidade informada' }}: {{ totalSelecionado }}
    </span>
  </div>

  @if (isLoading) {
    <div class="loading-row">
      <mat-spinner diameter="28"></mat-spinner>
      <span>Carregando séries disponíveis…</span>
    </div>
  }

  @if (erroCarga) {
    <div class="error-banner">{{ erroCarga }}</div>
  }

  <div class="bipe-form mt-2">
    <mat-form-field appearance="outline" class="field-bipe" subscriptSizing="dynamic">
      <mat-label>Bipar / digitar série</mat-label>
      <input matInput [(ngModel)]="bipeInput" placeholder="Código da série"
             (keydown.enter)="bipar()" />
    </mat-form-field>
    <button mat-flat-button class="btn-primary" (click)="bipar()" [disabled]="!bipeInput.trim()">
      <mat-icon>qr_code_scanner</mat-icon>
      Confirmar
    </button>
  </div>

  @if (errosBipe) {
    <div class="error-banner mt-1">{{ errosBipe }}</div>
  }

  @if (!isLoading && dataSource.data.length === 0) {
    <div class="empty-contacts">Nenhuma série com saldo disponível nesta localização.</div>
  } @else if (isNarrow) {
    <div class="modal-card-list">
      @for (row of dataSource.data; track row) {
        <div class="modal-card" [class.row-selecionada]="row.selecionada">
          <div class="modal-card__header">
            <div class="modal-card__ro modal-card__header-main">
              <small>Código da Série</small>
              <span>{{ row.codigoSerie }}</span>
            </div>
            <mat-checkbox [(ngModel)]="row.selecionada" (change)="dataSource.data = dataSource.data.slice()"></mat-checkbox>
          </div>
        </div>
      }
    </div>
  } @else {
    <div class="table-responsive mt-2">
      <table mat-table [dataSource]="dataSource" class="mat-elevation-z0 w-100 modal-tabela-cards">

        <ng-container matColumnDef="selecionada">
          <th mat-header-cell *matHeaderCellDef class="coluna-selecao">
            <mat-checkbox
              (change)="alternarTodasSeries()"
              [checked]="todasSeriesSelecionadas"
              [indeterminate]="algumaSerieSelecionada">
            </mat-checkbox>
          </th>
          <td mat-cell *matCellDef="let row" class="coluna-selecao">
            <mat-checkbox
              [(ngModel)]="row.selecionada"
              (change)="dataSource.data = dataSource.data.slice()">
            </mat-checkbox>
          </td>
        </ng-container>

        <ng-container matColumnDef="codigoSerie">
          <th mat-header-cell *matHeaderCellDef class="coluna-codigo-serie">Código da Série</th>
          <td mat-cell *matCellDef="let row" class="coluna-codigo-serie" [class.selecionada]="row.selecionada">
            {{ row.codigoSerie }}
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;" [class.row-selecionada]="row.selecionada"></tr>
      </table>
    </div>
  }

</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-stroked-button class="btn-secondary" (click)="cancelar()">Cancelar</button>
  <button mat-flat-button class="btn-primary" (click)="confirmar()" [disabled]="!totalOk">Confirmar</button>
</mat-dialog-actions>
